import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/auth';
import api from '../../services/api';
import List from '../../components/Crud/List';
import InvoicesFilter, { InvoiceFilterFields } from './InvoicesFilter';
import {
  getLastFilterByKey,
  upsertFilterToKey,
} from '../../services/filterService';
import InvoicesList from './InvoicesList';
import { InvoiceViewModel } from '../../models/Invoice/InvoiceViewModel';

export default function InvoicesIndex() {
  const pageKey = 'invoices';
  const [isLoading, setIsLoading] = useState(true);
  const [invoices, setInvoices] = useState([] as InvoiceViewModel[]);
  const [filterFields, setFilterFields] = useState<InvoiceFilterFields>(
    null as unknown as InvoiceFilterFields
  );

  const {
    user: { organization },
    isAdmin,
  } = useAuth();

  async function getInvoices(data: InvoiceFilterFields) {
    if (organization) {
      setIsLoading(true);
      const { isPaid, isNotPaid, ...rest } = data;
      const response = await api.get(
        `organizations/${organization.id}/invoices/filter`,
        {
          params: {
            isPaid: isPaid || undefined,
            isNotPaid: isNotPaid || undefined,
            ...rest,
          },
        }
      );
      setInvoices(response.data.data);
      setIsLoading(false);
    }
  }

  const onFilterSubmit = (data: InvoiceFilterFields) => {
    const filter = new InvoiceFilterFields(data);
    upsertFilterToKey(pageKey, filter);
    setFilterFields(filter);
    getInvoices(data);
  };

  useEffect(() => {
    const filters = getLastFilterByKey(pageKey, InvoiceFilterFields);
    setFilterFields(filters);
    getInvoices(filters);
  }, [organization]);

  return (
    <List
      isLoading={isLoading}
      title='Ordens de Serviço'
      newItemUrl='new'
      withNewAction={isAdmin}
      filter={
        <InvoicesFilter
          pageKey='invoices'
          filterFields={filterFields}
          onSubmit={onFilterSubmit}
        />
      }
    >
      <InvoicesList invoices={invoices} />
    </List>
  );
}
